(function($) {
    $(document)
        .on(
            'click',
            '.main-header__back-button, .main-header__partner__back',
            function(e) {
                if (
                    document.body.classList.contains(
                        'woocommerce-order-received',
                    )
                ) {
                    return;
                }

                e.preventDefault();

                history.go(-1);
            },
        );

    // Header-scrolling
    /*
    (function() {
        let didScroll;
        let lastScrollTop = 0;
        let minScroll = 5;

        const $body = $('body');

        $(window).scroll(function(event) {
            didScroll = true;
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            if (
                document.body.classList.contains('drawer-prevent-scrolling') ||
                document.body.classList.contains('dialog-prevent-scrolling')
            ) {
                return;
            }

            let st = $(this).scrollTop();

            // Make sure they scroll more than minScroll
            if (Math.abs(lastScrollTop - st) <= minScroll) {
                return;
            }

            // Scroll Up
            if (st < lastScrollTop) {

                if ( $('.single-product__content').length > 0 ) {
                    var checked_distanse = $('#root-single-product').offset().top - $('.main-header').outerHeight();
                    var body_scroll = $(document).scrollTop();
                    if ( body_scroll < checked_distanse ) {
                        $body.addClass('header-scrolled-up');
                        $body.removeClass('header-scrolled');
                        $body.removeClass('no-scroll');
                    }
                } else {
                    $body.addClass('header-scrolled-up');
                    $body.removeClass('header-scrolled');
                    $body.removeClass('no-scroll');
                }

            } else {
                $body.removeClass('header-scrolled-up');
                $body.addClass('header-scrolled');
                $body.removeClass('no-scroll');
            }

            if (st < 5) {
                $body.removeClass('header-scrolled-up');
                $body.removeClass('header-scrolled');
                $body.addClass('no-scroll');
            }

            lastScrollTop = st;
        }

        $(document).ready(function() {
            if ($(window).scrollTop() > 4) {
                $body.addClass('header-scrolled-up');
            }
        });
    }());
    */
    // Menu intersection control
    (function() {
        function isOutOfViewport(elem) {
            // Get element's bounding
            const bounding = elem.getBoundingClientRect();

            // Check if it's out of the viewport on each side
            const out = {};
            out.top = bounding.top < 0;
            out.left = bounding.left < 0;
            out.bottom =
                bounding.bottom >
                (window.innerHeight || document.documentElement.clientHeight);
            out.right =
                bounding.right >
                (window.innerWidth || document.documentElement.clientWidth);
            out.any = out.top || out.left || out.bottom || out.right;
            out.all = out.top && out.left && out.bottom && out.right;

            return out;
        }

        document.querySelectorAll('.menu .menu-item.menu-item-has-children')
            .forEach(menuItem => {
                menuItem.addEventListener('mouseenter', onEnter);
                menuItem.addEventListener('mouseleave', onLeave);
            });

        function onEnter(e) {
            if (!e.target.querySelector('.sub-menu-wrapper')) {
                return;
            }

            requestAnimationFrame(() => checkElementForIntersection(
                e.target.querySelector('.sub-menu-wrapper')),
            );
        }

        function onLeave(e) {
            if (!e.target.querySelector('.sub-menu-wrapper')) {
                return;
            }

            e.target.querySelector('.sub-menu-wrapper')
                .classList.remove('tiny', 'small');
        }

        function checkElementForIntersection(element) {
            const result = isOutOfViewport(element);
            if (!result.any) {
                return;
            }

            if (
                element.classList.contains('small') &&
                !element.classList.contains('tiny')
            ) {
                element.classList.add('tiny');
            } else if (!element.classList.contains('small')) {
                element.classList.add('small');

                checkElementForIntersection(element);
            }
        }

        if (document.querySelector("#scrollToTopBtn")) {
            // Scroll to top
            var scrollToTopBtn = document.getElementById("scrollToTopBtn");
            var rootElement = document.documentElement;
            function scrollToTop() {
                // Scroll to top logic
                rootElement.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            }
            scrollToTopBtn.addEventListener("click", scrollToTop)
        }

    }());
})(jQuery);
